<div id="billing-component">
    <!--class="bg-dark-grey"-->
    <ng-scrollbar class="regular-scrollbar">
        <div class="billing-scroll-content pt-4 pb-12">
            <nav
                class="billing-mobile-section-tabs"
                aria-label="Billing sections">
                <button
                    type="button"
                    [class.selected]="getMenu() === 'plans'"
                    [attr.aria-current]="getMenu() === 'plans' ? 'page' : null"
                    (click)="setMenu('plans')">
                    Subscription plans
                </button>
                <button
                    type="button"
                    [class.selected]="getMenu() === 'payment'"
                    [attr.aria-current]="
                        getMenu() === 'payment' ? 'page' : null
                    "
                    (click)="setMenu('payment')">
                    Payment methods
                </button>
            </nav>

            <div
                class="subscription-plans-container"
                *ngIf="getMenu() === 'plans'">
                <div class="mx-auto px-6 lg:px-8">
                    <div class="billing-plans-toolbar">
                        <span
                            class="billing-plans-toolbar-spacer"
                            aria-hidden="true"></span>
                        <fieldset aria-label="Payment frequency">
                            <div
                                class="grid grid-cols-2 gap-x-1 rounded-full bg-white/5 p-1 text-center text-xs font-semibold leading-5 text-white">
                                <label
                                    class="cursor-pointer rounded-full px-2.5 py-1"
                                    [ngClass]="{
                                        'bg-white text-gray-900':
                                            selectedBillingCycle === 'monthly'
                                    }"
                                    (click)="selectedBillingCycle = 'monthly'">
                                    <input
                                        type="radio"
                                        name="frequency"
                                        value="monthly"
                                        class="sr-only" />
                                    <span>Monthly</span>
                                </label>
                                <label
                                    class="cursor-pointer rounded-full px-2.5 py-1"
                                    [ngClass]="{
                                        'bg-white text-gray-900':
                                            selectedBillingCycle !== 'monthly'
                                    }"
                                    (click)="selectedBillingCycle = 'annually'">
                                    <input
                                        type="radio"
                                        name="frequency"
                                        value="annually"
                                        class="sr-only" />
                                    <span>Annually (Up to 33% off!)</span>
                                </label>
                            </div>
                        </fieldset>
                        <button
                            type="button"
                            class="billing-toolbar-button"
                            (click)="setMenu('payment')">
                            <span>Edit payment method</span>
                        </button>
                    </div>
                    <div class="mx-auto max-w-4xl text-center">
                        <p class="mt-3 text-base leading-7 text-white">
                            <i class="pricing-note"
                                ><img src="assets/img/renewal.svg" />{{
                                    showPricingNote()
                                }}</i
                            >
                        </p>
                    </div>
                    <div
                        #plansCarousel
                        class="billing-plans-carousel isolate mx-auto mt-6 grid max-w-md grid-cols-1 gap-4 lg:max-w-7xl lg:grid-cols-3"
                        role="region"
                        aria-label="Subscription plans"
                        tabindex="0"
                        (pointerdown)="markPlansCarouselInteracted()"
                        (wheel)="markPlansCarouselInteracted()"
                        (keydown)="markPlansCarouselInteracted()"
                        (scroll)="updatePlansCarouselIndicator()">
                        <div
                            class="billing-plan-card rounded-3xl p-6 xl:p-8"
                            data-plan-tier="free"
                            [ngClass]="{
                                'border border-white/80 bg-white/5':
                                    isCurrentPlan('free'),
                                'border border-white/10': !isCurrentPlan('free')
                            }">
                            <div
                                class="flex items-center justify-between gap-x-4">
                                <h3
                                    id="tier-freelancer"
                                    class="text-lg font-semibold leading-7 text-white">
                                    Free
                                </h3>
                            </div>
                            <p class="mt-4 flex items-baseline gap-x-1">
                                <!-- Price, update based on frequency toggle state -->
                                <span
                                    class="text-4xl font-bold tracking-tight text-white"
                                    >€0</span
                                >
                                <!-- Payment frequency, update based on frequency toggle state -->
                                <span
                                    class="text-sm font-semibold leading-6 text-gray-300"
                                    >/month</span
                                >
                            </p>
                            <a
                                *ngIf="showCurrentPlanForPlanType('free')"
                                aria-describedby="tier-freelancer"
                                class="mt-4 block rounded-md bg-white/10 px-3 py-2 text-center text-sm font-semibold leading-6 text-white hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                                >Current plan</a
                            >

                            <a
                                *ngIf="showDowngradeButtonForPlanType('free')"
                                aria-describedby="tier-freelancer"
                                (click)="changeSubscriptionForPlanType('free')"
                                class="grey-billing-button"
                                >Downgrade</a
                            >

                            <div
                                class="plan-willdowngrade"
                                *ngIf="showDowngradeMessageForPlanType('free')">
                                Downgrading on
                                {{
                                    subscription.end * 1000
                                        | date : "mediumDate"
                                }}
                            </div>

                            <div
                                class="loader subscription-loader"
                                *ngIf="
                                    showSubscriptionLoadingForPlanType('free')
                                "></div>

                            <ul
                                role="list"
                                class="billing-plan-features mt-6 space-y-2 text-sm leading-5 text-gray-300 xl:mt-8">
                                <li class="flex gap-x-3">
                                    <img
                                        src="assets/img/warning.svg"
                                        class="h-6 w-5 flex-none text-white" />
                                    Copyright owned by AIVA
                                </li>
                                <li class="flex gap-x-3">
                                    <img
                                        src="assets/img/warning.svg"
                                        class="h-6 w-5 flex-none text-white" />
                                    No monetization allowed
                                </li>
                                <li class="flex gap-x-3">
                                    <img
                                        src="assets/img/warning.svg"
                                        class="h-6 w-5 flex-none text-white" />
                                    Credit must be given to AIVA
                                </li>

                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Max songs per day: 5
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Unlimited downloads
                                </li>
                            </ul>
                        </div>
                        <div
                            class="billing-plan-card overflow-hidden rounded-3xl p-6 xl:p-8"
                            data-plan-tier="standard"
                            [ngClass]="{
                                'border border-white/80 bg-white/5':
                                    isCurrentPlan('standard'),
                                'border border-white/10':
                                    !isCurrentPlan('standard')
                            }">
                            <div
                                id="option-discount-header"
                                *ngIf="selectedBillingCycle == 'annually'">
                                26% OFF!
                            </div>

                            <div
                                class="flex items-center justify-between gap-x-4">
                                <h3
                                    id="tier-startup"
                                    class="text-lg font-semibold leading-7 text-white">
                                    {{
                                        selectedBillingCycle === "monthly"
                                            ? "Standard Monthly"
                                            : "Standard Annually"
                                    }}
                                </h3>
                            </div>
                            <p class="mt-4 flex items-baseline gap-x-1">
                                <!-- Price, update based on frequency toggle state -->
                                <span
                                    class="text-4xl font-bold tracking-tight text-white"
                                    >{{
                                        selectedBillingCycle === "monthly"
                                            ? "€15"
                                            : "€11"
                                    }}</span
                                >
                                <!-- Payment frequency, update based on frequency toggle state -->
                                <span
                                    class="text-sm font-semibold leading-6 text-gray-300"
                                    >/month + VAT</span
                                >
                            </p>
                            <a
                                *ngIf="
                                    showSubscribeButtonForPlanType('standard')
                                "
                                aria-describedby="tier-startup"
                                class="blue-billing-button"
                                (click)="
                                    changeSubscriptionForPlanType('standard')
                                "
                                >Select</a
                            >

                            <a
                                *ngIf="showCurrentPlanForPlanType('standard')"
                                aria-describedby="tier-freelancer"
                                class="current-plan"
                                ><img
                                    class="w-4 h-4 mr-2 mt-1"
                                    src="assets/img/checkmark.svg" />
                                <span>Current plan</span></a
                            >

                            <a
                                *ngIf="
                                    showDowngradeButtonForPlanType('standard')
                                "
                                aria-describedby="tier-freelancer"
                                (click)="
                                    changeSubscriptionForPlanType('standard')
                                "
                                class="grey-billing-button"
                                >Downgrade</a
                            >

                            <div
                                class="plan-willdowngrade"
                                *ngIf="
                                    showDowngradeMessageForPlanType('standard')
                                ">
                                Downgrading on
                                {{
                                    subscription.end * 1000
                                        | date : "mediumDate"
                                }}
                            </div>

                            <div
                                class="loader subscription-loader"
                                *ngIf="
                                    showSubscriptionLoadingForPlanType(
                                        'standard'
                                    )
                                "></div>

                            <ul
                                role="list"
                                class="billing-plan-features mt-6 space-y-2 text-sm leading-5 text-gray-300 xl:mt-8">
                                <li class="flex gap-x-3">
                                    <img
                                        src="assets/img/warning.svg"
                                        class="h-6 w-5 flex-none text-white" />
                                    Copyright owned by YOU
                                </li>
                                <li class="flex gap-x-3">
                                    <img
                                        src="assets/img/warning.svg"
                                        class="h-6 w-5 flex-none text-white" />
                                    Full monetization
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    No need to credit AIVA
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Songs per day: 40
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Songs per hour: 20
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Unlimited downloads
                                </li>
                            </ul>
                        </div>
                        <div
                            class="billing-plan-card overflow-hidden rounded-3xl p-6 xl:p-8"
                            data-plan-tier="pro"
                            [ngClass]="{
                                'border border-white/80 bg-white/5':
                                    isCurrentPlan('pro'),
                                'border border-white/10': !isCurrentPlan('pro')
                            }">
                            <div
                                id="option-discount-header"
                                *ngIf="selectedBillingCycle == 'annually'">
                                33% OFF!
                            </div>

                            <div
                                class="flex items-center justify-between gap-x-4">
                                <h3
                                    id="tier-enterprise"
                                    class="text-lg font-semibold leading-7 text-white">
                                    {{
                                        selectedBillingCycle === "monthly"
                                            ? "Pro Monthly"
                                            : "Pro Annually"
                                    }}
                                </h3>
                            </div>
                            <p class="mt-4 flex items-baseline gap-x-1">
                                <!-- Price, update based on frequency toggle state -->
                                <span
                                    class="text-4xl font-bold tracking-tight text-white"
                                    >{{
                                        selectedBillingCycle === "monthly"
                                            ? "€49"
                                            : "€33"
                                    }}</span
                                >
                                <!-- Payment frequency, update based on frequency toggle state -->
                                <span
                                    class="text-sm font-semibold leading-6 text-gray-300"
                                    >/month + VAT</span
                                >
                            </p>
                            <a
                                *ngIf="showSubscribeButtonForPlanType('pro')"
                                aria-describedby="tier-startup"
                                class="blue-billing-button"
                                (click)="changeSubscriptionForPlanType('pro')"
                                >Select</a
                            >

                            <a
                                *ngIf="showCurrentPlanForPlanType('pro')"
                                aria-describedby="tier-freelancer"
                                class="current-plan"
                                ><img
                                    class="w-4 h-4 mr-2 mt-1"
                                    src="assets/img/checkmark.svg" />
                                <span>Current plan</span></a
                            >

                            <a
                                *ngIf="showDowngradeButtonForPlanType('pro')"
                                aria-describedby="tier-freelancer"
                                (click)="changeSubscriptionForPlanType('pro')"
                                class="grey-billing-button"
                                >Downgrade</a
                            >

                            <div
                                class="plan-willdowngrade"
                                *ngIf="showDowngradeMessageForPlanType('pro')">
                                Downgrading on
                                {{
                                    subscription.end * 1000
                                        | date : "mediumDate"
                                }}
                            </div>

                            <div
                                class="loader subscription-loader"
                                *ngIf="
                                    showSubscriptionLoadingForPlanType('pro')
                                "></div>

                            <ul
                                role="list"
                                class="billing-plan-features mt-6 space-y-2 text-sm leading-5 text-gray-300 xl:mt-8">
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Copyright owned by YOU
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Full monetization
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    No need to credit AIVA
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Songs per day: 80
                                </li>
                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Songs per hour: 40
                                </li>

                                <li class="flex gap-x-3">
                                    <svg
                                        class="h-6 w-5 flex-none text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true">
                                        <path
                                            fill-rule="evenodd"
                                            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                                            clip-rule="evenodd" />
                                    </svg>
                                    Unlimited downloads
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="billing-carousel-indicators"
                        role="group"
                        aria-label="Choose subscription plan">
                        <button
                            *ngFor="let plan of planTiers; let i = index"
                            type="button"
                            class="billing-carousel-indicator"
                            [class.active]="activeMobilePlanIndex === i"
                            [attr.aria-pressed]="activeMobilePlanIndex === i"
                            [attr.aria-label]="'Show ' + plan.label + ' plan'"
                            (click)="showPlanInCarousel(i)"></button>
                    </div>
                </div>

                <div class="mx-auto max-w-7xl px-6 py-16 lg:px-8">
                    <div class="mx-auto max-w-4xl divide-y divide-white/10">
                        <h2
                            class="text-2xl font-bold leading-10 tracking-tight text-white">
                            Frequently asked questions
                        </h2>
                        <dl
                            class="mt-10 space-y-6 divide-y divide-white/10"
                            *ngFor="
                                let faq of frequentlyAskedQuestions;
                                let f = index
                            ">
                            <div class="pt-6">
                                <dt>
                                    <button
                                        (click)="faq.selected = !faq.selected"
                                        type="button"
                                        class="flex w-full items-start justify-between text-left text-white"
                                        aria-controls="faq-0"
                                        aria-expanded="false">
                                        <span
                                            class="text-base font-semibold leading-7"
                                            >{{ faq.question }}</span
                                        >
                                        <span
                                            class="ml-6 flex h-7 items-center">
                                            <svg
                                                class="h-6 w-6"
                                                [ngClass]="{
                                                    hidden: faq.selected
                                                }"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5"
                                                stroke="currentColor"
                                                aria-hidden="true">
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M12 6v12m6-6H6" />
                                            </svg>
                                            <svg
                                                class="h-6 w-6"
                                                [ngClass]="{
                                                    hidden: !faq.selected
                                                }"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke-width="1.5"
                                                stroke="currentColor"
                                                aria-hidden="true">
                                                <path
                                                    stroke-linecap="round"
                                                    stroke-linejoin="round"
                                                    d="M18 12H6" />
                                            </svg>
                                        </span>
                                    </button>
                                </dt>
                                <dd
                                    class="mt-2 pr-12"
                                    id="faq-0"
                                    [ngClass]="{ hidden: !faq.selected }">
                                    <p
                                        [innerHtml]="faq.answer"
                                        class="text-base text-left leading-7 text-gray-300"></p>
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>

            <div id="billing-container" [hidden]="getMenu() != 'payment'">
                <div class="billing-payment-toolbar">
                    <button
                        type="button"
                        class="billing-toolbar-button"
                        (click)="setMenu('plans')">
                        <img
                            class="billing-toolbar-chevron"
                            src="assets/img/chevron-left.svg"
                            alt=""
                            aria-hidden="true" />
                        <span>Back to subscription plans</span>
                    </button>
                </div>
                <div class="mt-8 flex justify-center">
                    <div class="settings-row" style="width: 550px">
                        <div class="settings-row-title">
                            <label
                                for="location"
                                class="inline-block align-middle text-left block text-sm font-medium leading-6 text-white"
                                >Payment Method</label
                            >
                        </div>
                        <div
                            class="payment-method-switcher"
                            role="radiogroup"
                            aria-label="Payment method">
                            <button
                                *ngIf="showCreditCardPaymentMethod"
                                type="button"
                                role="radio"
                                [class.selected]="
                                    getSelectedPM() === 'credit-card'
                                "
                                [attr.aria-checked]="
                                    getSelectedPM() === 'credit-card'
                                "
                                (click)="setSelectedPM('credit-card')">
                                Credit Card
                            </button>
                            <button
                                *ngIf="showPaypalPaymentMethod"
                                type="button"
                                role="radio"
                                [class.selected]="getSelectedPM() === 'paypal'"
                                [attr.aria-checked]="
                                    getSelectedPM() === 'paypal'
                                "
                                (click)="setSelectedPM('paypal')">
                                PayPal
                            </button>
                            <button
                                *ngIf="showWalletPaymentMethods"
                                type="button"
                                role="radio"
                                [class.selected]="
                                    getSelectedPM() === 'apple-pay'
                                "
                                [attr.aria-checked]="
                                    getSelectedPM() === 'apple-pay'
                                "
                                (click)="setSelectedPM('apple-pay')">
                                Apple Pay
                            </button>
                        </div>
                    </div>
                </div>

                <div class="payment-method-container bg-white/5">
                    <div
                        class="credit-card-container"
                        [hidden]="getSelectedPM() != 'credit-card'">
                        <div class="credit-card-header">
                            <div>
                                <div class="payment-method-title">
                                    Card details
                                </div>
                            </div>

                            <div
                                *ngIf="defaultPaymentMethod == 'credit-card'"
                                class="default-payment-method">
                                <img
                                    src="assets/img/checkmark.svg"
                                    alt=""
                                    aria-hidden="true" />
                                Default payment method
                            </div>
                        </div>

                        <div class="credit-card-form">
                            <div class="card-form-section-title">
                                Billing information
                            </div>
                            <input
                                [(ngModel)]="fullName"
                                placeholder="Full name or business name"
                                class="input full-input"
                                id="billing-address" />

                            <input
                                [(ngModel)]="address"
                                placeholder="Postal address"
                                class="input full-input"
                                id="billing-address" />
                            <input
                                [(ngModel)]="city"
                                placeholder="City"
                                class="input billing-address-city"
                                id="billing-address" />
                            <input
                                [(ngModel)]="zip"
                                placeholder="Postal code"
                                class="input"
                                id="billing-address" />

                            <select
                                id="billing-address-country"
                                [(ngModel)]="country"
                                class="input full-input billing-address-country"
                                placeholder="Select a country"
                                [class.custom-select]="changeSelectStyle">
                                <option
                                    *ngFor="let country of countries"
                                    [value]="country.countryCode"
                                    [selected]="
                                        country != null &&
                                        country == country.countryCode
                                    ">
                                    {{ country.name }} {{ country.emoji }}
                                </option>
                            </select>

                            <div class="card-form-section-title">
                                Card information
                            </div>
                            <input
                                [(ngModel)]="cardholderName"
                                placeholder="Name on card"
                                class="input full-input"
                                id="cardholder-name" />

                            <div class="full-input">
                                <div
                                    class="input full-input"
                                    id="card-number"></div>
                            </div>

                            <div>
                                <div
                                    class="input input-expiration-date"
                                    id="expiration-date"></div>
                            </div>

                            <div>
                                <div class="input" id="cvc"></div>
                            </div>
                        </div>

                        <div class="billing-error-message">
                            {{ cardNumberError }}
                        </div>
                        <div class="billing-error-message">
                            {{ expirationDateError }}
                        </div>

                        <a
                            aria-describedby="tier-startup"
                            class="hover:cursor-pointer mt-6 block rounded-md bg-aiva-blue px-3 py-2 text-center text-sm font-semibold leading-6 text-white shadow-sm hover:bg-aiva-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-aiva-blue"
                            (click)="setPaymentDetails()"
                            *ngIf="!addPaymentMethodLoading"
                            >Update Payment Method</a
                        >

                        <div
                            class="loader-container"
                            *ngIf="addPaymentMethodLoading">
                            <div class="loader"></div>
                        </div>
                    </div>

                    <div
                        class="apple-pay-container"
                        [hidden]="getSelectedPM() != 'apple-pay'">
                        <div class="payment-method-title">
                            Apple Pay Details
                        </div>

                        <div
                            class="message-box"
                            *ngIf="message.show"
                            [ngClass]="message.type">
                            <div
                                class="close-button"
                                (click)="messageService.hideMessage(message)">
                                <img src="assets/img/close.svg" />
                            </div>
                            <div class="text">{{ message.text }}</div>
                        </div>

                        <input
                            [(ngModel)]="fullName"
                            name="fullName"
                            placeholder="Full name or business name"
                            class="input full-input"
                            id="billing-address" />
                        <select
                            id="billing-address-country"
                            [(ngModel)]="country"
                            (ngModelChange)="onSelectCountry($event)"
                            class="input full-input billing-address-country"
                            placeholder="Country"
                            [class.custom-select]="changeSelectStyle">
                            <option [selected]="country == null">
                                Select a country
                                <img src="assets/img/down-dropdown.svg" />
                            </option>
                            <option
                                *ngFor="let country of countries"
                                [value]="country.countryCode"
                                [selected]="
                                    country != null &&
                                    country == country.countryCode
                                ">
                                {{ country.name }} {{ country.emoji }}
                            </option>
                        </select>

                        <div
                            id="wallet-pay-button"
                            class="wallet-pay-button"
                            *ngIf="canMakeWalletPayment"
                            [hidden]="
                                addPaymentMethodLoading ||
                                !getWalletPayIsSetup()
                            ">
                            <!-- THIS WILL BE RENDERED BY STRIPE ELEMENTS -->
                        </div>
                        <!-- Method to show Apple, Google Pays current payment request  -->
                        <div
                            class="modal-button add-payment-method"
                            (click)="createWalletPreview()"
                            *ngIf="
                                !addPaymentMethodLoading &&
                                !getWalletPayIsSetup() &&
                                canMakeWalletPayment
                            ">
                            <ng-container
                                *ngIf="subscribeThroughPaymentMethod != ''">
                                Continue with Apple Pay
                            </ng-container>
                            <ng-container
                                *ngIf="subscribeThroughPaymentMethod == ''">
                                Select a plan
                            </ng-container>
                        </div>
                        <div
                            class="loader-container"
                            *ngIf="addPaymentMethodLoading">
                            <div class="loader"></div>
                        </div>

                        <div
                            class="wallet-pay-not-available"
                            *ngIf="!canMakeWalletPayment">
                            Your device is not ready to use Apple Pay.
                        </div>
                    </div>

                    <div
                        class="paypal-container"
                        [hidden]="getSelectedPM() != 'paypal'">
                        <div class="paypal-header">
                            <div class="payment-method-title">
                                PayPal details
                            </div>

                            <div
                                *ngIf="defaultPaymentMethod == 'paypal'"
                                class="default-payment-method">
                                <img
                                    src="assets/img/checkmark.svg"
                                    alt=""
                                    aria-hidden="true" />
                                Default payment method
                            </div>
                        </div>

                        <div
                            class="message-box"
                            *ngIf="message.show"
                            [ngClass]="message.type">
                            <div
                                class="close-button"
                                (click)="messageService.hideMessage(message)">
                                <img src="assets/img/close.svg" />
                            </div>
                            <div class="text">{{ message.text }}</div>
                        </div>

                        <div class="paypal-form">
                            <div class="card-form-section-title">
                                Billing information
                            </div>
                            <input
                                [(ngModel)]="firstName"
                                name="firstName"
                                placeholder="First name"
                                class="input billing-address-city"
                                id="billing-address"
                                (ngModelChange)="
                                    checkBraintreeAdress($event)
                                " />
                            <input
                                [(ngModel)]="lastName"
                                name="lastName"
                                placeholder="Last name"
                                class="input"
                                id="billing-address"
                                (ngModelChange)="
                                    checkBraintreeAdress($event)
                                " />

                            <input
                                [(ngModel)]="address"
                                placeholder="Postal address"
                                class="input full-input"
                                id="billing-address"
                                (ngModelChange)="
                                    checkBraintreeAdress($event)
                                " />
                            <input
                                [(ngModel)]="city"
                                placeholder="City"
                                class="input billing-address-city"
                                id="billing-address"
                                (ngModelChange)="
                                    checkBraintreeAdress($event)
                                " />
                            <input
                                [(ngModel)]="zip"
                                placeholder="Postal code"
                                class="input"
                                id="billing-address"
                                (ngModelChange)="
                                    checkBraintreeAdress($event)
                                " />

                            <select
                                id="billing-address-country"
                                [(ngModel)]="country"
                                class="input full-input billing-address-country"
                                placeholder="Country"
                                [class.custom-select]="changeSelectStyle"
                                (ngModelChange)="checkBraintreeAdress($event)">
                                <option [selected]="country == null">
                                    Select a country
                                    <img src="assets/img/down-dropdown.svg" />
                                </option>
                                <option
                                    *ngFor="let country of countries"
                                    [value]="country.countryCode"
                                    [selected]="
                                        country != null &&
                                        country == country.countryCode
                                    ">
                                    {{ country.name }} {{ country.emoji }}
                                </option>
                            </select>
                        </div>

                        <div
                            class="loader-container"
                            *ngIf="addPaymentMethodLoading">
                            <div class="loader"></div>
                        </div>

                        <div
                            id="paypal-button-container"
                            [hidden]="
                                !paypalButtonVisible || addPaymentMethodLoading
                            ">
                            <div
                                *ngIf="defaultPaymentMethod"
                                class="update-paypal-payment-details">
                                To update your payment details, click on the
                                button below.
                            </div>
                            <div id="paypal-button"></div>
                        </div>

                        <div
                            class="message-box error"
                            *ngIf="
                                !paypalButtonVisible &&
                                defaultPaymentMethod != 'paypal' &&
                                !addPaymentMethodLoading &&
                                braintreeValidationErrors.length == 0
                            ">
                            <div class="text">
                                Please fill in all fields to continue.
                            </div>
                        </div>

                        <div
                            class="message-box error braintree-validation validation"
                            *ngIf="braintreeValidationErrors.length > 0">
                            <div
                                class="text"
                                *ngFor="let error of braintreeValidationErrors">
                                {{ error.message }}
                            </div>
                        </div>
                        <!-- <div *ngIf="defaultPaymentMethod != 'paypal'" class="form-hint create">
                        *Fill in and submit the form using the PayPal button to make PayPal your default payment method.
                    </div>
                    <div *ngIf="defaultPaymentMethod == 'paypal'" class="form-hint update">
                        *Fill in and submit submit the form using the PayPal button to make update your account info.
                    </div> -->
                        <!-- <div class="info-text" *ngIf="!paypalButtonVisible && defaultPaymentMethod == 'paypal' && !addPaymentMethodLoading">
                        PayPal is currently set as your default payment method. If you want to change that, please contact support!
                    </div> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-scrollbar>
</div>
